App.namespace.wrap('components.history_state', ({ onChange }) => {
  const supported = (!!window.history && window.history.pushState);

  // Tells onChange whether the traversal came from this helper or from the browser itself (its
  // back/forward buttons, iOS edge swipes) - the browser already animates its own page transition.
  let ownTraversalPending = false;

  window.addEventListener('popstate', (event) => {
    if (!supported) {
      return;
    }

    const isOwnTraversal = ownTraversalPending;
    ownTraversalPending = false;

    onChange(event, { isOwnTraversal });
  });

  const pushState = (id, title, hash) => {
    if (!supported) {
      return;
    }

    history.pushState(id, title, hash);
  };

  const replaceState = (id, title) => {
    if (!supported) {
      return;
    }

    history.replaceState(id, title);
  };

  const getState = () => {
    if (!supported) {
      return null;
    }

    return history.state;
  };


  const go = (delta) => {
    if (!supported) {
      return;
    }

    ownTraversalPending = true;
    history.go(delta);
  };

  const back = () => go(-1);

  return {
    pushState,
    replaceState,
    getState,
    back,
    go,
  };
});
